<template>
  <div style="width: 100%">
    <div v-if="$slots.headerTop" style="margin: 5px">
      <slot name="headerTop"></slot>
    </div>
    <div class="flex items-center">
      <TableTitle
        v-if="!$slots.tableTitle && title"
        :title="title"
        :helpMessage="titleHelpMessage"
        :count="count"
        :total="total"
      />
      <slot v-if="$slots.tableTitle" name="tableTitle"></slot>
      <TableBatchBar v-if="showBatchBar" v-bind="batchBar">
        <template v-for="item in Object.keys($slots)" #[item]="data" :key="item">
          <slot :name="item" v-bind="data || {}"></slot>
        </template>
      </TableBatchBar>
      <div :class="`${prefixCls}__toolbar`">
        <slot name="toolbar"></slot>
        <Divider v-if="$slots.toolbar && showTableSetting" type="vertical" />
        <TableSettingComponent
          v-if="showTableSetting"
          :setting="tableSetting"
          @columns-change="handleColumnChange"
        />
      </div>
    </div>
    <div v-if="showSelectionBar" style="margin-top: 8px">
      <slot v-if="$slots.selectionBar" name="selectionBar" v-bind="props"></slot>
      <TableSelectionBar
        v-else
        :clearSelectedRowKeys="props.clearSelectedRowKeys!"
        :count="props.count"
        :total="props.total"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { Divider } from 'ant-design-vue';
  import type { PropType } from 'vue';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import type {
    BatchBarConfig,
    ColumnChangeParam,
    TableActionType,
    TableSetting,
  } from '../types/table';
  import TableSettingComponent from './settings/index.vue';
  import TableBatchBar from './TableBatchBar.vue';
  import TableSelectionBar from './TableSelectionBar.vue';
  import TableTitle from './TableTitle.vue';

  defineOptions({ name: 'BasicTableHeader' });

  const props = defineProps({
    title: {
      type: [Function, String] as PropType<string | ((data) => string)>,
    },
    tableSetting: {
      type: Object as PropType<TableSetting>,
    },
    showTableSetting: {
      type: Boolean,
    },
    batchBar: {
      type: Object as PropType<BatchBarConfig>,
    },
    showBatchBar: {
      type: Boolean,
      default: false,
    },
    titleHelpMessage: {
      type: [String, Array] as PropType<string | string[]>,
      default: '',
    },
    //
    clearSelectedRowKeys: {
      type: Function as PropType<TableActionType['clearSelectedRowKeys']>,
    },
    count: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    showSelectionBar: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(['columns-change']);
  const { prefixCls } = useDesign('basic-table-header');
  function handleColumnChange(data: ColumnChangeParam[]) {
    emit('columns-change', data);
  }
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-basic-table-header';

  .@{prefix-cls} {
    &__toolbar {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: flex-end;

      > * {
        margin-right: 8px;
      }
    }
  }
</style>
